import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import _ from 'lodash';
import SimpleReactValidator from 'simple-react-validator';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import { history } from '../../../shared/configure-store';

const validator = new SimpleReactValidator({
    messages: {
        required: 'Field ini wajib diisi',
        min: 'Silakan pilih minimal satu customer',
    },
});

class RegionalSetupAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingButton: false,
            errors: {},
            regional_codes: [],
            corporate_customers: [],
            regional_name: '',
            regional_code: '',
            user_id: [],
            isManage: false,
        };
    }

    componentDidMount() {
        document.title = 'Gudangemas - Buat Regional Setup';
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map((o) => ({
                id: o.id,
                name: o.menu.name,
                isManage: o.isManage,
            }));


            // TODO: FIX PERMISSION TO REGIONAL SETUP
            let all = roles.filter(item => item.name === 'Daftar Produk');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });
        }

        this.fetchRegionalCodes();
        this.fetchCorporateCustomers();
    }

    fetchRegionalCodes = () => {
        Api.get('/region/master').then(resp => {
            if (resp.data) {
                let all = [];
                _.forEach(resp.data, (v, k) => all.push(v));
                this.setState({ regional_codes: all, loading: false });
            }
        });
    };

    fetchCorporateCustomers = () => {
        const params = {
            page: 0,
            size: 1000,
            'type-of-customer': 'CORPORATE',
        };
    
        Api.post('/customer/get-all', params)
            .then(resp => {
                if (resp.data && resp.data.customers) {
                    this.setState({ 
                        corporate_customers: resp.data.customers.map(c => ({
                            id: c['id-customer'],
                            name: `${c.username || ''} - ${c.companyName || ''}`,
                        })),
                        loading: false 
                    });
                }
            });
    };

    handleChange = (e, prop) => {
        this.setState({ [prop]: e.target.value });
    };

    handleUserSelect = (selectedUsers) => {
        this.setState({ user_id: selectedUsers });
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return;
        }

        this.setState({ loadingButton: true });

        const params = {
            regional_name: this.state.regional_name,
            regional_code: this.state.regional_code,
            user_id: this.state.user_id.map(user => user.id),
        };

        Api.post('/region/setup', params)
            .then((resp) => {
                this.setState({ loadingButton: false });

                if (resp.status === 400 && resp.message && resp.message[0] === "Periksa Kembali User yang akan di setup") {
                    this.showMessage(false, 'Silakan periksa kembali Customer yang anda pilih, kemungkinan Customer tersebut telah terdaftar di Regional Setup lain');
                    return;
                }

                if (resp.status === 200 || resp.status === 201) {
                    history.push('/regional-setup');
                    this.showMessage(true, 'Regional setup berhasil ditambahkan');
                } else {
                    this.showMessage(false, 'Terjadi kesalahan saat menambahkan regional setup');
                }
            })
            .catch((err) => {
                this.setState({ loadingButton: false });
                this.showMessage(false, 'Terjadi kesalahan saat menambahkan regional setup');
            });
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Buat Regional Setup</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/regional-setup">Regional Setup</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Tambah
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Tambah Regional Setup</h2>
                            </div>
                        </div>
                        <h3 className="section-title"></h3>
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Nama Komunitas</label>
                                        <TextField
                                            variant="outlined"
                                            value={this.state.regional_name}
                                            error={this.state.errors.regional_name}
                                            helperText={this.state.errors.regional_name}
                                            onChange={(e) => this.handleChange(e, 'regional_name')}
                                            fullWidth
                                        />
                                        {validator.message('regional_name', this.state.regional_name, 'required')}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Kode Regional</label>
                                        <TextField 
                                            id="regional_code"
                                            name="regional_code"
                                            variant="outlined"
                                            value={this.state.regional_code}
                                            error={this.state.errors.regional_code}
                                            helperText={this.state.errors.regional_code}
                                            onChange={(e) => this.handleChange(e, 'regional_code')}
                                            select
                                            fullWidth
                                        >
                                            {this.state.regional_codes.map(option => (<MenuItem key={option.regional_code} value={option.regional_code}>{option.regional_code}</MenuItem>))}
                                        </TextField>
                                        {validator.message('regional_code', this.state.regional_code, 'required')}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>List Customer (Corporate) di Regional Ini</label>
                                        <Autocomplete
                                            multiple
                                            options={this.state.corporate_customers}
                                            getOptionLabel={(option) => option.name}
                                            value={this.state.user_id}
                                            onChange={(_, value) => this.handleUserSelect(value)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label="Pilih Customer"
                                                    placeholder="Pilih Customer (Corporate)"
                                                    error={this.state.errors.user_id}
                                                    helperText={this.state.errors.user_id}
                                                    fullWidth
                                                />
                                            )}
                                        />
                                        {validator.message('user_id', this.state.user_id, 'required|array|min:1')}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-center mt-4">
                                    <Button
                                        variant="contained"
                                        onClick={() => history.push('/regional-setup')}
                                        className="mr-3"
                                    >
                                        Batal
                                    </Button>
                                    {this.state.isManage && (
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            disabled={this.state.loadingButton}
                                        >
                                            Simpan { this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default RegionalSetupAdd;